import api from './api';

// Kampane Effzone (produktové správy naprieč firmami) — len prehľad a brzda.
// Kampane sa vytvárajú cez Claude (Effzone Analytics MCP), nie tu.
// Endpointy chránené role='admin' (kontrakt kampaní, kap. 7).

const list = (status) => api.get('/admin/campaigns', { params: { ...(status ? { status } : {}), limit: 100 } });

const detail = (id) => api.get(`/admin/campaigns/${id}`);

const cancel = (id) => api.post(`/admin/campaigns/${id}/cancel`);

const pauseAll = () => api.post('/admin/campaigns/pause-all');

const resumeAll = () => api.post('/admin/campaigns/resume-all');

const CampaignService = { list, detail, cancel, pauseAll, resumeAll };

export default CampaignService;
